import {
  SET_SHOW_PUBLISH,
  SET_IS_CART,
  SET_ORDER_OBJ,
  SET_TALKBAO_INDEX,
  SET_IMPRINT_INDEX,
  SET_SHOW_UPDATENUM,
  SET_FOCUS_ADDREMARK,
  SET_USER_INFO,
  SET_BOOTHSTORE_DETAIL,
  SET_ORDER_KEYID,
  SET_IGET_SALESNUM,
  SET_IGET_UPDATESALESNUM,
  SET_BACK_WAITORDER,
  SET_ADD_REMARKTEXT,
  SET_ADD_REMARKOBJ,
  SET_VIDEO_SHOW,
  SET_VIDEO_SRC,
  SET_Home_POP,
  SET_STORE_ID,
  SET_NFC_READTXT,
  SET_NFC_WRITETXT,
  SET_WRITE_STATE,
  SET_REDIRECT_TO,
  CLEAR_REDIRECT_TO,
  SET_USER_ID, SET_IS_APP, SET_IS_WECHAT, SET_PAY_INFO, SET_APP_TYPE, SET_SHOP_CART_NUM,
  SET_ORDER_DATA, CLEAR_ORDER_DATA,
  SET_PERMISSIONS, CLEAR_PERMISSIONS
} from './mutations-type'

/**
 * 📌 作用：
 * 用于处理异步请求（如 API 调用）
 * 不能直接修改 state，只能通过提交 mutations 来修改 state
 * ✅ 如何使用 actions？
 *
 * javascript
 * 复制
 * 编辑
 * this.$store.dispatch('setUserId', 12345);
 * 📌 注意：
 *
 * actions 可以执行异步操作
 * 但它不能直接修改 state，只能调用 mutations 来修改 state
 */
export default {
  //新增或者已整理的
  setUserId({ commit }, data) {
    commit(SET_USER_ID, data);
  },

  //未整理的
  initializeHint({commit}) {
    const hintExpiration = localStorage.getItem('downloadHintExpiration');
    const now = new Date().getTime();

    // 判断是否在 iWebView 环境中
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isWebView = /wv|WebView/i.test(userAgent);

    console.log('--------initializeHint ', now, hintExpiration, 'isWebView:', isWebView);

    if (isWebView) {
      // 在 iWebView 环境中，设置提示为不可见
      commit('setHintVisible', false);
    } else {
      // 检查本地存储的过期时间
      if (hintExpiration && now < parseInt(hintExpiration)) {
        // 如果当前时间小于过期时间，则设置提示为不可见
        commit('setHintVisible', false);
      } else {
        // 如果没有过期时间或已过期，则显示提示
        commit('setHintVisible', true);
      }
    }
  },

  updateTabActive(state, active) {
    state.active = active
  },
  setShowPublish({
                   commit
                 }, data) {
    commit(SET_SHOW_PUBLISH, data)
  },
  setIsCart({
              commit
            }, data) {
    commit(SET_IS_CART, data)
  },
  setOrderObj({
                commit
              }, data) {
    commit(SET_ORDER_OBJ, data)
  },
  setTalkbaoIndex({
                    commit
                  }, data) {
    commit(SET_TALKBAO_INDEX, data)
  },
  setGuangguangIndex({
                       commit
                     }, data) {
    commit(SET_GUANGGUANG_INDEX, data)
  },
  setImprintIndex({
                    commit
                  }, data) {
    commit(SET_IMPRINT_INDEX, data)
  },
  setShowUpdateNum({
                     commit
                   }, data) {
    commit(SET_SHOW_UPDATENUM, data)
  },
  setFocusAddRemark({
                      commit
                    }, data) {
    commit(SET_FOCUS_ADDREMARK, data)
  },
  //设置用户id
  setUserInfo({
                commit
              }, data) {
    commit(SET_USER_INFO, data)
  },

  //设置展台店铺详情
  setBoothStoreDetail({
                        commit,
                        state
                      }, data) {
    console.log('在action中获取state:', state);
    commit(SET_BOOTHSTORE_DETAIL, data)
  },
  //设置订单主键id
  setOrderKeyId({
                  commit,
                  state
                }, data) {
    commit(SET_ORDER_KEYID, data)
  },
  //保存我抢到的弹出框文本
  setIGetSalesNum({
                    commit
                  }, data) {
    commit(SET_IGET_SALESNUM, data)
  },
  //保存我抢到的弹出框对应的商品
  setIGetUpdateSalesNum({
                          commit
                        }, data) {
    commit(SET_IGET_UPDATESALESNUM, data)
  },
  setBackWaitOrder({
                     commit
                   }, data) {
    commit(SET_BACK_WAITORDER, data)
  },
  setAddRemarkText({
                     commit
                   }, data) {
    commit(SET_ADD_REMARKTEXT, data)
  },
  setAddRemarkObj({
                    commit
                  }, data) {
    commit(SET_ADD_REMARKOBJ, data)
  },
  setVideoShow({
                 commit
               }, data) {
    commit(SET_VIDEO_SHOW, data)
  },
  setVideoSrc({
                commit
              }, data) {
    commit(SET_VIDEO_SRC, data)
  },
  setHomePop({
               commit
             }, data) {
    commit(SET_Home_POP, data)
  },
  setStoreId({
               commit
             }, data) {
    commit(SET_STORE_ID, data)
  },
  setNfcReadTxt({
                  commit
                }, data) {
    commit(SET_NFC_READTXT, data)
  },
  setNfcWriteTxt({
                   commit
                 }, data) {
    commit(SET_NFC_WRITETXT, data)
  },
  setWriteState({
                  commit
                }, data) {
    commit(SET_WRITE_STATE, data)
  },

  // NFC
  enableReadMode({commit}) {
    commit('SET_READ_MODE', true);
    commit('SET_WRITE_MODE', false);
    commit('SET_PROCESSING', false);
  },
  enableWriteMode({commit}) {
    commit('SET_READ_MODE', false);
    commit('SET_WRITE_MODE', true);
    commit('SET_PROCESSING', false);
  },
  resetModes({commit}) {
    commit('SET_READ_MODE', false);
    commit('SET_WRITE_MODE', false);
    commit('SET_PROCESSING', false);
  },
  setMultipleWrite({commit}, status) {
    commit('SET_MULTIPLE_WRITE', status);
  },
  setResourceId({commit}, resourceId) {
    commit('SET_RESOURCE_ID', resourceId);
  },

  saveRedirectTo({commit}, route) {
    commit(SET_REDIRECT_TO, route);
  },
  clearRedirectTo({commit}) {
    commit(CLEAR_REDIRECT_TO);
  },

  setIsApp({commit}, status) {
    commit(SET_IS_APP, status);
  },
  setIsWechat({commit}, status) {
    commit(SET_IS_WECHAT, status)
  },

  setPayInfo({commit}, payInfo) {
    commit(SET_PAY_INFO, payInfo);
  },

  setAppType({ commit }, appType) {
    commit(SET_APP_TYPE, appType);
  },
  setShopCartNum({commit}, num) {
    commit(SET_SHOP_CART_NUM, num)
  },

  // 订单数据管理
  setOrderData({commit}, orderData) {
    commit(SET_ORDER_DATA, orderData)
  },
  clearOrderData({commit}) {
    commit(CLEAR_ORDER_DATA)
  },

  // 权限管理
  setPermissions({commit}, permissions) {
    commit(SET_PERMISSIONS, permissions)
  },
  clearPermissions({commit}) {
    commit(CLEAR_PERMISSIONS)
  },
  
  // 获取并设置权限
  async fetchPermissions({commit}) {
    try {
      // 这里需要导入storeUserApi
      const storeUserApi = await import('@/api/v3/storeUser');
      const permissions = await storeUserApi.default.getPermissions();
      commit(SET_PERMISSIONS, permissions);
      return permissions;
    } catch (error) {
      console.error('获取权限失败:', error);
      commit(SET_PERMISSIONS, []);
      throw error;
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js